/*
 * @Author: monai
 * @Date: 2021-05-11 15:33:23
 * @LastEditors: muqing
 * @LastEditTime: 2024-09-10 15:39:31
 */

import LanguageTextCache from './getLangText_cacheClass';
import HttpClient from '@library/httpClient_activity.js';
import { fnColorLog, fnParamsCheck } from '@activity-business/h5-package-frameworkTool';
import {getQueryString,fnAjaxCustomHeaders} from '@activity-business/h5-package-frameworkTool';

let getLangText: DevelopToolShare.GetLangText = (app, parameter) => {

    //  默认使用接口文案
    let { useAjaxText, useLocalText, activityId, countryCode, localText, reactiveText } = parameter;

    if (useAjaxText) {
        //  参数校验、错误提示
        if (fnParamsCheck({ activityId, countryCode })) return;
        //  文案缓存
        let languageCache = new LanguageTextCache(activityId, countryCode, <string[]>reactiveText);

        const encrypt = getQueryString('encrypt')
        if(!encrypt){
            fnColorLog(['developTool_Share', '已使用接口文案'], 'error', '参数获取失败,请添加加密串参数');
            throw new Error(`参数获取失败, 活动ID: ${activityId}, country: ${countryCode}, Error: 请添加加密串参数`);
        }

        HttpClient(<any>{ 
            url:'/api/activity/share/decryptConfigs',
            params:{ secretValue: encrypt },
            ajaxCustomHeaders: {
                headers: {},
                cb: config => {
                    const deleteKeys:string[] = ['did', 'uid', 'key', 'version'];
                    deleteKeys.forEach(key => delete config.headers[key]);
                }
            }
        }).then(response => {
                let { data: { data, errorCode } } = response;
                if (errorCode != 0) throw response;
                
                let textArr: string[] = data.list.map(item => item.content);
                //  接口文案是否与当前是否的文案匹配
                if (!languageCache.matchCache(textArr)) {
                    //  更新数据
                    (<string[]>reactiveText).splice(0, (<string[]>reactiveText).length, ...textArr);
                    fnColorLog(['developTool_TS', '已使用接口文案'], 'success', reactiveText);
                }
                //  更新数据
                languageCache.updateDate(textArr);
            })
            .catch(err => {
                console.log(`[${new Date().toLocaleString()}] - err`, err);
                if (![10015].includes(err?.data?.errorCode)) {
                    // throw new Error(`文案接口获取失败, 活动ID: ${activityId}, country: ${countryCode}, Error: ${err?.message ?? JSON.stringify(err)}`);
                };
            });
    }

    if (useLocalText) {
        //  参数校验、错误提示
        if (fnParamsCheck({ localText, countryCode })) return;
        Object.assign(<object>reactiveText, localText![countryCode!] || {});
        fnColorLog(['developTool_TS', '已使用 local 文案'], 'info', reactiveText);
    }
};

export default getLangText;